import React, { Component } from "react";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import { find } from "lodash";
import autobind from "autobind-decorator";
import { Link } from "react-router";
import { connect } from "react-redux";
import * as flags from "utils/feature-flags";
import { selectFeatureFlag } from "redux/modules/lenndFlags";
import UnauthorizedAccess from "components/Global/UnauthorizedAccess";

import DocumentTitle from "components/Global/DocumentTitle";
import { MODULES } from "components/Global/NavIcons";

@CSSModules(css)
class SettingsHandler extends Component {
  getIcon(tabKey) {
    if (MODULES[tabKey]) {
      return MODULES[tabKey].icon;
    }
    return "";
  }

  @autobind
  activeTab(tabKey) {
    if (find(this.props.routes, { name: "accountSettingsSettings" })) {
      return tabKey === "settings";
    }
    if (find(this.props.routes, { name: "accountSettingsFeatureFlags" })) {
      return tabKey === "featureFlags";
    }
    return false;
  }

  render() {
    const { isSuperAdmin, routes } = this.props;
    const isFeatureFlagsRoute = find(routes, {
      name: "accountSettingsFeatureFlags"
    });

    if (isFeatureFlagsRoute && !isSuperAdmin) {
      return <UnauthorizedAccess />;
    }

    return (
      <DocumentTitle title="Account - Settings">
        <div styleName="container">
          <div styleName="leftColumn">
            <div styleName="navHeading">
              <span styleName="navIcon">{this.getIcon("settings")}</span>{" "}
              Settings
            </div>
            <Link
              to="/account/settings"
              styleName={
                this.activeTab("settings") ? "navItemActive" : "navItem"
              }
            >
              Account Settings
            </Link>
            {isSuperAdmin && (
              <Link
                to="/account/feature-flags"
                styleName={
                  this.activeTab("featureFlags") ? "navItemActive" : "navItem"
                }
              >
                Feature Flags
              </Link>
            )}
          </div>
          <div styleName="rightColumn">
            {React.cloneElement(this.props.children, {
              user: this.props.user,
              params: this.props.params,
              showModal: this.props.showModal,
              hideModal: this.props.hideModal,
              dispatch: this.props.dispatch,
              showSnackbar: this.props.showSnackbar
            })}
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = state => ({
  isSuperAdmin: selectFeatureFlag(flags.IS_SUPER_ADMIN.NAME)(state)
});

export default connect(mapStateToProps)(SettingsHandler);
